<template>
  <div class="hc-compact-page">
    <!-- Header Alert -->
    <b-alert
      show
      variant="light"
      class="alert alert-custom alert-white alert-shadow fade show gutter-b"
    >
      <div class="alert-icon">
        <span class="svg-icon svg-icon-lg">
          <inline-svg src="/media/svg/icons/Tools/Compass.svg" />
        </span>
      </div>
      <div class="alert-text"><b>Pendaftar Medhop</b></div>
      <b-button
        variant="primary"
        @click="$router.push('/registrants/add')"
        v-if="btnAccess"
        >Tambah</b-button
      >
    </b-alert>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <!-- Filter & Search Toolbar -->
            <div class="row align-items-center mt-n2 mb-4">
              <div class="col-lg-8 col-md-12 mb-3 mb-lg-0">
                <div class="filter-buttons-group">
                  <button
                    class="btn btn-timeseries"
                    @click="btnActiveOnClick('days')"
                    v-bind:class="{
                      'btn-info': btnActive.days,
                      'btn-outline-info': btnActive.days == false,
                    }"
                  >
                    Hari Ini
                  </button>
                  <button
                    class="btn btn-timeseries"
                    @click="btnActiveOnClick('month')"
                    v-bind:class="{
                      'btn-info': btnActive.month,
                      'btn-outline-info': btnActive.month == false,
                    }"
                  >
                    Bulan Ini
                  </button>
                  <button
                    class="btn btn-timeseries"
                    @click="btnActiveOnClick('lastMonth')"
                    v-bind:class="{
                      'btn-info': btnActive.lastMonth,
                      'btn-outline-info': btnActive.lastMonth == false,
                    }"
                  >
                    Bulan Kemarin
                  </button>
                  <button
                    class="btn btn-timeseries"
                    @click="btnActiveOnClick('year')"
                    v-bind:class="{
                      'btn-info': btnActive.year,
                      'btn-outline-info': btnActive.year == false,
                    }"
                  >
                    Tahun Ini
                  </button>
                  <button
                    class="btn btn-timeseries"
                    v-bind:class="{
                      'btn-info': btnActive.period,
                      'btn-outline-info': btnActive.period == false,
                    }"
                    @click="btnPeriodeOnClick"
                  >
                    Periode
                  </button>
                </div>
              </div>
              <div class="col-lg-4 col-md-12">
                <div class="search-box-wrapper">
                  <div class="search-input-control">
                    <i class="fas fa-search search-icon"></i>
                    <b-form-input
                      type="text"
                      v-model="filter.clinic_name"
                      placeholder="Cari nama klinik..."
                      class="search-input"
                      @keyup.enter="filterByName"
                    ></b-form-input>
                  </div>
                  <b-button @click="filterByName" class="btn-search">Cari</b-button>
                  <b-button @click="resetFilter" class="btn-reset">Reset</b-button>
                </div>
              </div>
            </div>

            <!-- timeseries filter -->
            <div class="row mt-3" v-if="onShowPeriod">
              <div class="col-md-12">
                <div class="period-datepicker-wrapper">
                  <span class="d-none d-sm-flex align-items-center gap-2">
                    <div class="datepicker-container">
                      <b-form-input
                        v-model="filter.start_date"
                        type="text"
                        placeholder="Awal"
                        autocomplete="off"
                        readonly
                        class="datepicker-input"
                      ></b-form-input>
                      <b-form-datepicker
                        v-model="filter.start_date"
                        button-only
                        right
                        reset-button
                        locale="id"
                        button-variant="link"
                      ></b-form-datepicker>
                    </div>
                    <span class="mx-2 text-muted">s/d</span>
                    <div class="datepicker-container">
                      <b-form-input
                        v-model="filter.end_date"
                        type="text"
                        placeholder="Akhir"
                        autocomplete="off"
                        readonly
                        class="datepicker-input"
                      ></b-form-input>
                      <b-form-datepicker
                        v-model="filter.end_date"
                        button-only
                        right
                        reset-button
                        locale="id"
                        button-variant="link"
                      ></b-form-datepicker>
                    </div>
                    <b-button @click="pagination" class="btn-search ml-3">Terapkan</b-button>
                    <b-button @click="resetFilter" class="btn-reset">Batal</b-button>
                  </span>
                  
                  <span class="d-block d-sm-none">
                    <div class="row">
                      <div class="col-12 mb-2">
                        <div class="datepicker-container">
                          <b-form-input
                            v-model="filter.start_date"
                            type="text"
                            placeholder="Awal"
                            autocomplete="off"
                            readonly
                            class="datepicker-input"
                          ></b-form-input>
                          <b-form-datepicker
                            v-model="filter.start_date"
                            button-only
                            right
                            reset-button
                            locale="id"
                            button-variant="link"
                          ></b-form-datepicker>
                        </div>
                      </div>
                      <div class="col-12 mb-2">
                        <div class="datepicker-container">
                          <b-form-input
                            v-model="filter.end_date"
                            type="text"
                            placeholder="Akhir"
                            autocomplete="off"
                            readonly
                            class="datepicker-input"
                          ></b-form-input>
                          <b-form-datepicker
                            v-model="filter.end_date"
                            button-only
                            right
                            reset-button
                            locale="id"
                            button-variant="link"
                          ></b-form-datepicker>
                        </div>
                      </div>
                      <div class="col-12 d-flex gap-2">
                        <b-button @click="pagination" class="btn-search w-100">Terapkan</b-button>
                        <b-button @click="resetFilter" class="btn-reset w-100">Batal</b-button>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>

            <b-table
              striped
              hover
              :items="items"
              :fields="fields"
              class="mt-3"
              responsive
            >
              <template #table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.key === 'action' ? '25%' : '' }"
                />
              </template>

              <template #cell(photo)="data">
                <div
                  class="
                    d-flex
                    justify-content-start
                    align-items-center
                    image-container
                  "
                >
                  <div class="image-input-wrapper" style="position: relative">
                    <img class="image" :src="data.item.photo" />
                  </div>
                </div>
              </template>

              <template #cell(email)="data">
                {{ data.item.email }}/ {{ data.item.phone }}
              </template>

              <template #cell(city_id)="data">
                {{ data.item.city_name }}, {{ data.item.province_name }}
              </template>

              <template #cell(status_display)="data">
                <span :class="getStatusBadgeClass(data.item.provisioning_status)">
                  {{ data.item.status_display }}
                </span>
              </template>

              <template #cell(action)="data">
                <b-button
                  size="sm"
                  class="btn-icon btn-light-primary mr-1"
                  v-b-tooltip.hover
                  title="Lihat Tenant"
                  @click="
                    $router.push({
                      path: `/registrants/tenant-information/${data.item.clinic_subdomain}`,
                    })
                  "
                  ><i class="fas fa-server"></i
                ></b-button>
                <b-button
                  size="sm"
                  class="btn-icon btn-light-info mr-1"
                  v-b-tooltip.hover
                  title="Detail"
                  @click="
                    $router.push({
                      path: '/registrants/detail/' + data.item.id,
                    })
                  "
                  ><i class="fas fa-eye"></i
                ></b-button>
                <b-button
                  size="sm"
                  class="btn-icon btn-light-success mr-1"
                  v-b-tooltip.hover
                  title="Edit"
                  @click="
                    $router.push({
                      path: '/registrants/edit/' + data.item.id,
                    })
                  "
                  ><i class="fas fa-edit"></i
                ></b-button>
                <b-button
                  size="sm"
                  class="btn-icon btn-light-danger"
                  v-b-tooltip.hover
                  title="Hapus"
                  @click="deleteData(data.item.id)"
                  v-if="data.item.status != 1"
                  ><i class="fas fa-trash"></i
                ></b-button>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import module from "@/core/modules/CrudModule.js";
import Table from "@/view/components/users/Table.vue";
import moment from "moment";

export default {
  name: "master-users",
  components: {
    Table,
  },
  data() {
    return {
      // filter
      filter: {
        clinic_name: "",
        start_date: moment().startOf("month").startOf("day").format("YYYY-MM-DD HH:mm:ss"),
        end_date: moment().endOf("month").endOf("day").format("YYYY-MM-DD HH:mm:ss"),
      },
      // filter timeseries
      onShowPeriod: false,
      btnActive: {
        days: false,
        month: true,
        lastMonth: false,
        year: false,
        period: false,
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      lastCurrentPage: 1,
      totalRows: 1,
      fields: [
        {
          key: "number",
          label: "No",
          sortable: true,
        },
        {
          key: "clinic_name",
          label: "Nama Klinik",
          sortable: true,
        },
        {
          key: "clinic_subdomain",
          label: "Subdomain",
          sortable: true,
        },
        {
          key: "name",
          label: "Pendaftar",
          sortable: true,
        },
        {
          key: "email",
          label: "Email / No. WA",
          sortable: true,
        },
        {
          key: "city_id",
          label: "Kota/Kabupaten",
          sortable: true,
        },
        {
          key: "register_date",
          label: "Tgl. Daftar",
          sortable: true,
        },
        {
          key: "status_display",
          label: "Status",
          sortable: true,
        },
        {
          key: "action",
          label: "Aksi",
          tdClass: "nowrap",
        },
      ],
      items: [],
      refreshTimer: null,
      // access
      btnAccess: true,
    };
  },
  methods: {
    pageOnClick(evt, page) {
      evt.preventDefault();
      this.currentPage = page;
      this.lastCurrentPage = page;
      this.pagination();
    },

    getStatusBadgeClass(status) {
      if (status === "active") {
        return "badge badge-light-success font-weight-bold px-4 py-2 rounded-pill";
      } else if (status === "failed") {
        return "badge badge-light-danger font-weight-bold px-4 py-2 rounded-pill";
      } else if (status === "provisioning") {
        return "badge badge-light-warning font-weight-bold px-4 py-2 rounded-pill";
      } else {
        return "badge badge-light-primary font-weight-bold px-4 py-2 rounded-pill";
      }
    },

    async pagination() {
      let filterParams = `&clinic_name=${this.filter.clinic_name}&start_date=${this.filter.start_date}&end_date=${this.filter.end_date}`;
      try {
        let response = await module.paginate(
          "registrants",
          `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`
        );
        if (!response || !response.meta || !response.meta.pagination) {
          return;
        }
        let pagination = response.meta.pagination;
        this.totalRows = pagination.total;

        let a, b;
        b = this.perPage * (this.currentPage - 1) + 1;
        if (Array.isArray(response.data)) {
          for (a = 0; a < response.data.length; a++) {
            response.data[a].number = b + a;
          }
          this.items = response.data;
        }
      } catch (error) {
        console.error("Failed to load registrants", error);
      }
    },

    filterByName() {
      this.filter.start_date = "";
      this.filter.end_date = "";
      // set btn Active
      this.btnActive.days = false;
      this.btnActive.month = false;
      this.btnActive.lastMonth = false;
      this.btnActive.year = false;
      this.btnActive.period = false;

      // hide period
      this.onShowPeriod = false;
      if (this.filter.clinic_name != "") {
        this.currentPage = 1;
      } else {
        this.currentPage = this.lastCurrentPage;
      }
      this.pagination();
    },

    btnPeriodeOnClick() {
      if (this.onShowPeriod == false) {
        this.onShowPeriod = true;
        this.btnActiveOnClick("period");
      } else {
        this.onShowPeriod = false;
        this.btnActiveOnClick("period");
      }
    },

    btnActiveOnClick(type) {
      if (type == "days") {
        // set time
        this.filter.start_date = moment()
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        this.filter.end_date = moment()
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");

        // get data

        // set btn Active
        this.btnActive.days = true;
        this.btnActive.month = false;
        this.btnActive.lastMonth = false;
        this.btnActive.year = false;
        this.btnActive.period = false;

        // hide period
        this.onShowPeriod = false;
      } else if (type == "month") {
        // set time
        this.filter.start_date = moment()
          .startOf("month")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        this.filter.end_date = moment()
          .endOf("month")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");

        // get data

        // set btn Active
        this.btnActive.days = false;
        this.btnActive.month = true;
        this.btnActive.lastMonth = false;
        this.btnActive.year = false;
        this.btnActive.period = false;

        // hide period
        this.onShowPeriod = false;
      } else if (type == "lastMonth") {
        // set time
        this.filter.start_date = moment()
          .subtract(1, "months")
          .startOf("month")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        this.filter.end_date = moment()
          .subtract(1, "months")
          .endOf("month")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");

        // get data

        // set btn Active
        this.btnActive.days = false;
        this.btnActive.month = false;
        this.btnActive.lastMonth = true;
        this.btnActive.year = false;
        this.btnActive.period = false;

        // hide period
        this.onShowPeriod = false;
      } else if (type == "year") {
        // set time
        this.filter.start_date = moment()
          .startOf("year")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        this.filter.end_date = moment()
          .endOf("year")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");

        // get data

        // set btn Active
        this.btnActive.days = false;
        this.btnActive.month = false;
        this.btnActive.lastMonth = false;
        this.btnActive.year = true;
        this.btnActive.period = false;

        // hide period
        this.onShowPeriod = false;
      } else if (type == "period") {
        // set time
        this.filter.start_date = "";
        this.filter.end_date = "";

        // set btn Active
        this.btnActive.days = false;
        this.btnActive.month = false;
        this.btnActive.lastMonth = false;
        this.btnActive.year = false;
        this.btnActive.period = true;
      }

      if (type != "period") {
        if (this.filter.start_date != "" || this.filter.end_date != "") {
          this.currentPage = 1;
        } else {
          this.currentPage = this.lastCurrentPage;
        }

        this.pagination();
      }
    },

    resetFilter() {
      // set time
      this.filter.start_date = moment()
        .startOf("month")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      this.filter.end_date = moment()
        .endOf("month")
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      // set btn Active
      this.btnActive.days = false;
      this.btnActive.month = true;
      this.btnActive.lastMonth = false;
      this.btnActive.year = false;
      this.btnActive.period = false;

      // hide period
      this.onShowPeriod = false;

      this.filter.clinic_name = "";

      this.pagination();
    },

    async deleteData(id) {
      // Delete Data
      let result = await module.delete("registrants/" + id);
      // If Deleted
      if (result) {
        this.pagination();
      }
    },

    // access
    checkAccess() {
      let access_right_user = window.localStorage.getItem(
        "access_right_display"
      );
      let access_right = JSON.parse(access_right_user);
      for (let a = 0; a < access_right.length; a++) {
        if (access_right[a] == "9002") {
          this.btnAccess = true;
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Pendaftar Medhop", route: "/registrants/" },
    ]);
    this.pagination();
    this.checkAccess();

    this.refreshTimer = window.setInterval(() => {
      this.pagination()
    }, 300000);
  },
  beforeDestroy() {
    if (this.refreshTimer) window.clearInterval(this.refreshTimer);
  },
};
</script>

<style lang="scss" scoped>
.nowrap {
  white-space: nowrap;
}

.hc-compact-page {
  font-family: "Poppins", "Inter", sans-serif;
}

/* Custom styles aligning to the website theme */
.alert-custom {
  border-radius: 16px !important;
  border: 1px solid rgba(231, 237, 244, 0.92) !important;
  box-shadow: 0 10px 30px rgba(20, 50, 99, 0.03) !important;
  background: #ffffff !important;
  padding: 16px 24px !important;
  display: flex;
  align-items: center;
  
  .alert-icon {
    background-color: rgba(30, 149, 143, 0.08) !important;
    border-radius: 12px;
    padding: 10px;
    color: #1e958f !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    
    svg {
      fill: #1e958f !important;
      color: #1e958f !important;
      width: 20px;
      height: 20px;
    }
  }

  .alert-text {
    color: #1e293b;
    font-size: 15px;
    font-weight: 600;
    flex-grow: 1;
  }

  /* Tambah Button */
  .btn-primary {
    background: linear-gradient(135deg, #14608f, #1e958f) !important;
    border: none !important;
    border-radius: 10px !important;
    padding: 8px 20px !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    box-shadow: 0 4px 12px rgba(30, 149, 143, 0.2) !important;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba(30, 149, 143, 0.3) !important;
    }
  }
}

/* Card Styling */
.card {
  border-radius: 18px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 12px 36px rgba(20, 50, 99, 0.03) !important;
  background: #ffffff;
  overflow: hidden;
}

/* Filter buttons container */
.filter-buttons-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* Timeseries Filter Buttons */
.btn-timeseries {
  border-radius: 30px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  padding: 8px 18px !important;
  transition: all 0.25s ease;
  border: 1px solid #e2e8f0 !important;
  color: #64748b !important;
  background: #ffffff !important;
  box-shadow: 0 2px 4px rgba(0,0,0,0.02) !important;
  
  &:hover {
    background: #f8fafc !important;
    color: #1e293b !important;
    border-color: #cbd5e1 !important;
  }
  
  &.btn-info {
    background: linear-gradient(135deg, #14608f, #1e958f) !important;
    border-color: transparent !important;
    color: #ffffff !important;
    box-shadow: 0 4px 12px rgba(30, 149, 143, 0.2) !important;
  }
}

/* Search input controls */
.search-box-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  
  .search-input-control {
    position: relative;
    flex-grow: 1;
    
    .search-icon {
      position: absolute;
      left: 14px;
      top: 50%;
      transform: translateY(-50%);
      color: #94a3b8;
      font-size: 13px;
      pointer-events: none;
    }
    
    .search-input {
      padding-left: 36px !important;
      height: 40px !important;
      border-radius: 10px !important;
      border: 1px solid #e2e8f0 !important;
      background-color: #f8fafc !important;
      font-size: 13px !important;
      
      &:focus {
        border-color: #1e958f !important;
        background-color: #ffffff !important;
        box-shadow: 0 0 0 3px rgba(30, 149, 143, 0.1) !important;
      }
    }
  }
  
  .btn-search {
    background: linear-gradient(135deg, #14608f, #1e958f) !important;
    border: none !important;
    color: white !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    height: 40px !important;
    padding: 0 20px !important;
    border-radius: 10px !important;
    box-shadow: 0 4px 10px rgba(30, 149, 143, 0.15) !important;
    transition: all 0.2s ease;
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 14px rgba(30, 149, 143, 0.25) !important;
    }
  }
  
  .btn-reset {
    background-color: #f1f5f9 !important;
    border: 1px solid #e2e8f0 !important;
    color: #64748b !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    height: 40px !important;
    padding: 0 16px !important;
    border-radius: 10px !important;
    transition: all 0.2s ease;
    
    &:hover {
      background-color: #e2e8f0 !important;
      color: #1e293b !important;
    }
  }
}

/* Datepicker Styling */
.period-datepicker-wrapper {
  background: #f8fafc;
  padding: 16px;
  border-radius: 12px;
  border: 1px dashed #e2e8f0;
  display: flex;
  align-items: center;
  
  .datepicker-container {
    display: flex;
    align-items: center;
    position: relative;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding-right: 8px;
    
    .datepicker-input {
      border: none !important;
      box-shadow: none !important;
      background: transparent !important;
      height: 38px !important;
      width: 140px;
      font-size: 13px !important;
    }
  }
}

/* Table Styling */
.table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  
  ::v-deep thead th {
    background-color: #f8fafc !important;
    color: #475569 !important;
    font-size: 11px !important;
    font-weight: 700 !important;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    padding: 14px 16px !important;
    border-bottom: 2px solid #edf2f7 !important;
    border-top: none !important;
  }
  
  ::v-deep tbody td {
    padding: 16px !important;
    vertical-align: middle !important;
    color: #334155 !important;
    font-size: 13px !important;
    border-bottom: 1px solid #edf2f7 !important;
  }
  
  ::v-deep tbody tr {
    transition: background-color 0.2s ease;
    
    &:hover {
      background-color: rgba(30, 149, 143, 0.02) !important;
    }
  }
}

/* Avatar/Image Wrapper */
.image-container {
  .image-input-wrapper {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid #fff;
    box-shadow: 0 3px 8px rgba(0,0,0,0.1);
    
    .image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

/* Custom Badge Styles */
.badge-light-success {
  background-color: rgba(30, 149, 143, 0.08) !important;
  color: #1e958f !important;
}
.badge-light-warning {
  background-color: rgba(245, 158, 11, 0.08) !important;
  color: #d97706 !important;
}
.badge-light-primary {
  background-color: rgba(20, 96, 143, 0.08) !important;
  color: #14608f !important;
}
.badge-light-danger {
  background-color: rgba(239, 68, 68, 0.08) !important;
  color: #ef4444 !important;
}

/* Action Buttons */
.btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px !important;
  padding: 0 !important;
  border: none !important;
  transition: all 0.2s ease;
  
  i {
    font-size: 12px !important;
  }
  
  &.btn-light-primary {
    background-color: rgba(20, 96, 143, 0.08) !important;
    
    i {
      color: #14608f !important;
    }
    
    &:hover {
      background-color: #14608f !important;
      i {
        color: #fff !important;
      }
    }
  }
  
  &.btn-light-info {
    background-color: rgba(56, 189, 248, 0.12) !important;
    
    i {
      color: #0284c7 !important;
    }
    
    &:hover {
      background-color: #0284c7 !important;
      i {
        color: #fff !important;
      }
    }
  }
  
  &.btn-light-success {
    background-color: rgba(30, 149, 143, 0.08) !important;
    
    i {
      color: #1e958f !important;
    }
    
    &:hover {
      background-color: #1e958f !important;
      i {
        color: #fff !important;
      }
    }
  }
  
  &.btn-light-danger {
    background-color: rgba(239, 68, 68, 0.08) !important;
    
    i {
      color: #ef4444 !important;
    }
    
    &:hover {
      background-color: #ef4444 !important;
      i {
        color: #fff !important;
      }
    }
  }
}
</style>
